if (!customElements.get('brand-logos')) {
  class BrandLogos extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.brand-logos__items',
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      };

      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
        swiperSlide: 'swiper-slide',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
      this.columnsDesktop = parseInt(this.dataset.columnsDesktop) || 6;
      this.enableSliderDesktop = this.dataset.enableSliderDesktop === 'true';

      this.sliderInstance = false;
      this.init();
    }

    init() {
      if (this.enableSliderDesktop) {
        this.initSlider();
      } else {
        this.destroySlider();
      }
    }

    initSlider() {
      const sliderOptions = {
        modules: [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination, FoxTheme.Swiper.Mousewheel],
        slidesPerView: 'auto',
        spaceBetween: 8,
        navigation: {
          nextEl: this.section.querySelector('.swiper-controls--header .swiper-button-next'),
          prevEl: this.section.querySelector('.swiper-controls--header .swiper-button-prev'),
        },
        pagination: false,
        loop: false,
        threshold: 2,
        autoHeight: true,
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        breakpoints: {
          768: {
            spaceBetween: 20,
            slidesPerView: this.columnsDesktop > 4 ? 4 : this.columnsDesktop,
            slidesPerGroup: 1,
          },
          1024: {
            spaceBetween: 20,
            slidesPerView: this.columnsDesktop > 6 ? 6 : this.columnsDesktop,
            slidesPerGroup: 1,
          },
          1280: {
            spaceBetween: 20,
            slidesPerView: this.columnsDesktop,
            slidesPerGroup: 1,
          },
        },
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        // Add swiper-slide class to children columns
        const children = this.sliderWrapper.children;
        for (let i = 0; i < children.length; i++) {
          children[i].classList.add(this.classes.swiperSlide);
        }

        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);
        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });

        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            let { target } = e;
            const index = Number(target.dataset.index);
            this.sliderInstance.slider.slideTo(index);
          });
        }
      }
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);

      // Remove swiper-slide class from children columns
      const children = this.sliderWrapper.children;
      for (let i = 0; i < children.length; i++) {
        children[i].classList.remove(this.classes.swiperSlide);
      }

      if (typeof this.sliderInstance !== 'object') return;
      this.sliderInstance.slider.destroy();
      this.sliderInstance = false;
    }
  }
  customElements.define('brand-logos', BrandLogos);
}
